export default "__VITE_ASSET__6WNTTXi3__"